import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const menuUiEvents = eventGroup({
  source: 'Modeler Burger Menu UI',
  events: {
    autolayoutTriggered: type<void>(),
  },
});
